import React, { useEffect } from 'react';
import { useParams, generatePath, useHistory } from 'react-router-dom';
import { createState, useState } from '@hookstate/core';
import {
    Box,
    TextField,
    Divider,
    CircularProgress
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEventState } from '../../../stores/eventStore';
import Helper from '../../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
import { FULL_PERMISSION } from '../../../constants/Constant';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import Title from '../../../sharedcomponents/title/title';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';

const ActivityState = createState({
    ActivityEvent: '',
    ActivityLocation: '',
    allActivityID: '',
    isDisable: false,
});
const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const CombineCreateAllActivity = (props) => {
    const classes = useStyles();
    const eventState = useEventState();
    const state = useState(ActivityState);
    // const userInfo = Helper.getStorage('userInfo');

    const loading = useState(false);
    let params = useParams();

    const history = useHistory();

    const [activityEventErr, setActivityEventErr] = React.useState('');
    const [activityLocationErr, setActivityLocationErr] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [disableCreateBtn, setDisableCreateBtn] = React.useState(false);

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            // if (!Helper.isAdminUser(userInfo) && !Helper.isEventStaff(userInfo)) {
            //     setModPermission(VIEW_PERMISSION);
            // } else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
            setModPermission(FULL_PERMISSION);
            // }
        }
    }, [eventState]);
    const handleBtnCancel = () => {
        props.history.goBack();
    };

    useEffect(() => {
        if (modPermission && modPermission == FULL_PERMISSION) {

            if (params.allActivityID) {
                if (history.location.state.AllActivityState) {
                    const allActivityState = history.location.state.AllActivityState;

                    state.set({
                        ActivityEvent: allActivityState.name,
                        ActivityLocation: allActivityState.location,
                        allActivityID: allActivityState.activityTrackerID,
                    });
                }
            } else {
                resetState();
            }
        }
    }, [params.allActivityID, modPermission]);

    const resetState = () => {
        state.set({
            ActivityEvent: '',
            ActivityLocation: '',
            allActivityID: '',
        });
    };

    const validateEventName = () => {
        let isValid = true;
        let value = state.ActivityEvent?.get().trim();
        if (value === '') {
            setActivityEventErr('Please Enter Activity Event');
            isValid = false;
        }
        return isValid;
    };

    const validateActivityLocation = () => {
        let value = state.ActivityLocation?.get().trim();
        if (value === '') {
            setActivityLocationErr('Please Enter Activity Room');
            return { flag: 'false', messages: 'Please Enter Activity Room' };
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');

        if (validateEventName()) {
            const activityPostData = {
                activityTrackerID: params.allActivityID > 0 ? params.allActivityID : 0,
                eventID: eventInfo.eventID,
                name: state.ActivityEvent.get().trim(),
                isDeleted: 0,
                createdBy: userInfo.userID.toString()
            }
            loading.set(true);
            state.isDisable.set(false);
            setDisableCreateBtn(true);
            ApiHelper.post(APIURLConstants.POST_INS_UPD_TRACKER, activityPostData)
                .then((res) => {
                    if (res.data !== "") {
                        state.isDisable.set(false);
                        if (res.data > 0 && params.allActivityID) {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Activity updated successfully',
                            });
                        } else {
                            if (res.data !== -1) {
                                setSnackBarProps({
                                    openSnack: true,
                                    variant: 'success',
                                    message: 'Activity added successfully',
                                });
                            }
                            else {
                                setSnackBarProps({
                                    openSnack: true,
                                    variant: 'error',
                                    message: 'Same Activity Already Present',
                                });
                                loading.set(false);
                                return
                            }


                        }
                        setTimeout(() => {
                            props.history.push(
                                generatePath(RouteConstants.COMBINE_ALL_ACTIVITIES, {
                                    eventID: eventInfo.eventID,
                                })
                            );
                        }, 1000);
                        loading.set(false);
                    }
                })
                .catch((error) => {
                    loading.set(false);
                    state.isDisable.set(false);
                    disableCreateBtn(false);
                    console.log('Error : ', error);
                    if (error.response && error.response.status === 401) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        }
    };

    const handleDisableBtn = () => {
        if (params.allActivityID > 0) {
            const AllActivityState = history.location.state.AllActivityState;
            const prevData = {
                ActivityEvent: AllActivityState.name,
                ActivityLocation: AllActivityState.location,
            }
            const currentData = {
                ActivityEvent: state.get().ActivityEvent,
                ActivityLocation: state.get().ActivityLocation,
            };

            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }
    }
    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission != FULL_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Box
                    component="form"
                    className="contentBox"
                    sx={{
                        width: '100%',
                        backgroundColor: '#fff',
                        '& .MuiFormControl-root': { width: '100%' },
                    }}
                    onSubmit={handleSubmit}>
                    <Box>
                        <Title title="Add Activity Tracker" />
                    </Box>
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'column', lg: 'row' },
                                padding: 0,
                                flex: 1,
                                marginTop: 1,
                            }}>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flex: 0.5,
                                    alignItems: 'center',
                                    padding: 1,
                                }}>
                                <TextField
                                    required={true}
                                    size="small"
                                    id="outlined-required"
                                    label="Activity Event"
                                    autoComplete="off"
                                    onBlur={validateEventName}
                                    value={state.ActivityEvent.get()}
                                    onChange={(event) => {
                                        state.ActivityEvent.set(event.target.value),
                                            setActivityEventErr('');
                                        handleDisableBtn();
                                    }}
                                    error={
                                        activityEventErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        activityEventErr.length > 0
                                            ? activityEventErr
                                            : ''
                                    }
                                    inputProps={{ maxLength: 50 }}
                                />
                            </Box>

                            {/* <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flex: 0.5,
                                    alignItems: 'center',
                                    padding: 1,
                                }}>
                                <TextField
                                    required={true}
                                    size="small"
                                    id="outlined-required"
                                    label="Activity Room"
                                    autoComplete="off"
                                    onBlur={validateActivityLocation}
                                    value={state.ActivityLocation.get()}
                                    onChange={(event) => {
                                        state.ActivityLocation.set(event.target.value),
                                            setActivityLocationErr('');
                                        handleDisableBtn();
                                    }}
                                    error={
                                        activityLocationErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        activityLocationErr.length > 0
                                            ? activityLocationErr
                                            : ''
                                    }
                                    inputProps={{ maxLength: 50 }}
                                />
                            </Box> */}
                        </Box>

                    </>

                    <Divider component="div" sx={{ mt: 2 }} />
                    <ButtonContainer
                        handleCancel={handleBtnCancel}
                        buttonText={params.allActivityID > 0 ? 'Update' : 'Create'}
                        disableButton={null}
                        disableUpdateButton={params.allActivityID > 0 ? disableBtn : false}
                    />

                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: false,
                                })
                            }></CustomizedSnackbars>
                    )}
                </Box>
            )}

        </>
    );
};
export default {
    routeProps: {
        path: [
            RouteConstants.COMBINE_CREATE_ALL_ACTIVITIES,
            RouteConstants.COMBINE_EDIT_ALL_ACTIVITIES,
        ],
        component: CombineCreateAllActivity,
    },
    name: 'CombineCreateAllActivity',
};
